import { call, put, takeLatest } from "redux-saga/effects";
import { insurancePurchaseRequest, insurancePurchaseSuccess, insurancePurchaseFailure } from "../../slice/travel-insurance/purchaseSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
import i18n from "../../../../i18n";
const fetchPurchaseData = async purchaseReq => {
  const FETCH_INSURANCE_API_URL = config.DAPI_INSURANCE_PURCHASE_API;
  const data = {
    mode: "no-cors",
    headers: {
      "Accept-Language": `${i18n.language}`,
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: false
  };
  const response = await api.post(`${FETCH_INSURANCE_API_URL}`, purchaseReq, data);
  return response;
};
function* getInsurancePurchaseData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchPurchaseData, payload);
    yield put(insurancePurchaseSuccess(response.data));
  } catch (error) {
    yield put(insurancePurchaseFailure(error));
  }
}
export function* watchInsurancePurchase() {
  yield takeLatest(insurancePurchaseRequest.type, getInsurancePurchaseData);
}